export const profilePage: any = {
    overlay: 'Profile',
    errorDefault: 'Oops!, Something went wrong. Please try again',
    successMsg: 'Successfully updated your profile',
    password: {
        'auth/too-many-requests': 'Too many attempty try again later',
        'auth/email-already-in-use': 'Email is already in use',
        'auth/invalid-email': 'Invalid Email Address',
        'auth/operation-not-allowed': 'Operation not allowed. Please try again.',
        'auth/weak-password': 'Please make a stronger password',
    }
};
